var Operations;
(function (Operations) {
    Operations["CREATE"] = "CREATE";
    Operations["GET"] = "GET";
    Operations["LIST"] = "LIST";
    Operations["COUNT"] = "COUNT";
    Operations["UPDATE"] = "UPDATE";
    Operations["DELETE"] = "DELETE";
    Operations["UPSERT"] = "UPSERT";
    Operations["MULTI_UPSERT"] = "MULTI_UPSERT";
})(Operations || (Operations = {}));
export default Operations;
